
import SectorReportsWrapper from '@/components/marketAnalysis/SectorReportsWrapper';
import SectorBarChart from '@/components/marketAnalysis/SectorBarChart';

export default {
    name: 'SectorReportsSection',

    components: {
        SectorReportsWrapper,
        SectorBarChart,
    },

    props: {
        isArchiveSectorPage: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            seclectedSector: null,
        };
    },

    head() {
        return {
            titleTemplate: `%s | ${this.$t('pages.marketAnalysis.sector.head.titleTemplate')}`,
            title: this.$t('pages.marketAnalysis.sector.head.title'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.marketAnalysis.sector.head.description'),
                },  
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('pages.marketAnalysis.sector.head.ogTitle'),
                },  
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: this.$t('pages.marketAnalysis.sector.head.ogDescription'),
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.$t('pages.marketAnalysis.sector.head.twitterTitle'),
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.$t('pages.marketAnalysis.sector.head.twitterDescription'),
                }
            ],  
        }
    },
}
